
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexlA_CNBEztHQCyTsimifkMBAQgRs_45NFi3eFaAlf0Dks0Meta } from "/tmp/build_847345ee/pages/app/me/index.vue?macro=true";
import { default as meDxWqzKY51H4C5P2OehYTCCw4l8_3C08xHGzcW_45ravJoMeta } from "/tmp/build_847345ee/pages/app/me.vue?macro=true";
import { default as mapX5qKEBh7Lvff1VFLeXAFs3_eOpUeBXhrH_45Y4dcZn9M0Meta } from "/tmp/build_847345ee/pages/app/map.vue?macro=true";
import { default as post7o97b7_45c4mSOxLtUGH1h3XgyKt4HiQc_45QlPkYMlV6_4Meta } from "/tmp/build_847345ee/pages/app/feed/post.vue?macro=true";
import { default as indexaaf2etMhWwpptohDr_453S7VCGqqUtG8qzKDhAzfEJ_H8Meta } from "/tmp/build_847345ee/pages/app/feed/index.vue?macro=true";
import { default as _91type_934Dwdq87YCVehhoH_45liZigNC0P_45CnOzHBUHnrtvDOLdQMeta } from "/tmp/build_847345ee/pages/app/feed/[type].vue?macro=true";
import { default as feedSeVcC4KYwgKSTdGJE6NbRGBpm_45DlK0jqoK4CStDhnIEMeta } from "/tmp/build_847345ee/pages/app/feed.vue?macro=true";
import { default as indexEz9iaK2LToV2IhcF0ED5w2DJZEpoilwSMGsLS4g_45_45PQMeta } from "/tmp/build_847345ee/pages/app/index.vue?macro=true";
import { default as eulaWtccuKlG8o1Y9mMGNbxT5z7MXBQk_45ma7f7XiiTqEE1UMeta } from "/tmp/build_847345ee/pages/main/eula.vue?macro=true";
import { default as indexSvOlR_niYgYm1hegBwfNLMeSy9KeLRGfFK_45dpJo921AMeta } from "/tmp/build_847345ee/pages/app/groups/index.vue?macro=true";
import { default as edithDRZtVChPRQ_45F_45HIHTAB3Br0CCx_45OPIfsjlO2gjZrdoMeta } from "/tmp/build_847345ee/pages/app/groups/[slug]/edit.vue?macro=true";
import { default as about4veBCndN8RSDm1CIcz3hUsAJwMgryf0jBCv0XG76tKUMeta } from "/tmp/build_847345ee/pages/app/groups/[slug]/about.vue?macro=true";
import { default as indexFebRozQeoD94NTA0t6XVTDPXPm0g2GDfQCoSEGKMAKgMeta } from "/tmp/build_847345ee/pages/app/groups/[slug]/index.vue?macro=true";
import { default as eventsFUuDIrxzZ0C90X_DJZhjikJxuHTcoBJnFa5JaR_ZYksMeta } from "/tmp/build_847345ee/pages/app/groups/[slug]/events.vue?macro=true";
import { default as membersAdyEnSyiihx9Nv23N_ift3G5MOWwTu8wh51IxyqDQDwMeta } from "/tmp/build_847345ee/pages/app/groups/[slug]/members.vue?macro=true";
import { default as conversationsw6gnIzUnNxaFqfcb35Y2i_45y2VB_45ziYqBeDsUDV8aBPYMeta } from "/tmp/build_847345ee/pages/app/groups/[slug]/conversations.vue?macro=true";
import { default as _91slug_93EfaMJaQZSghK3O5KRazaEPaBCL_QIbZ7VdboW9uuvwcMeta } from "/tmp/build_847345ee/pages/app/groups/[slug].vue?macro=true";
import { default as createmcKzQe03ux01fVmMm_45YGWTbKcw0yi_c3cgwrwLCKbAEMeta } from "/tmp/build_847345ee/pages/app/groups/create.vue?macro=true";
import { default as groupsAM8a0nYmFzhB8Kgwjz93SkrCUaowiKtYgekQXhKNrNkMeta } from "/tmp/build_847345ee/pages/app/groups.vue?macro=true";
import { default as indexYYo9pj2EAkrmagVoP0iN_45OyVdLsvwbHUbtzjBYKPgQcMeta } from "/tmp/build_847345ee/pages/app/params/index.vue?macro=true";
import { default as accountPmXaOoOGZkEvXdGl_LXcfIHQez9dzynJdSpX5uMPnl8Meta } from "/tmp/build_847345ee/pages/app/params/account.vue?macro=true";
import { default as transactionsH7AfTiWw4baDLFTr4mFmaD_45D8KSXTjylp5FEhE28oDwMeta } from "/tmp/build_847345ee/pages/app/params/transactions.vue?macro=true";
import { default as paramsv92FLnDMF_458iBXPSkOcqqJrVwAXAEKt3Jy59Ji9kFrAMeta } from "/tmp/build_847345ee/pages/app/params.vue?macro=true";
import { default as index0yfs3znmcdd5z6uG0XpaGfWMyPb3gk_45RGrLrVYLv3EkMeta } from "/tmp/build_847345ee/pages/main/index.vue?macro=true";
import { default as press1njoSVCAVG2tnyPHDiZzwx0Hq8UAVOljPqlEMUFX3ZQMeta } from "/tmp/build_847345ee/pages/main/press.vue?macro=true";
import { default as codesqomOj9Tsag6qA0RFI2_45AQLh4b9VHasGSsgvGX1y_45MQkMeta } from "/tmp/build_847345ee/pages/admin/codes.vue?macro=true";
import { default as index1FZk7mAEXGB9gOqsysdDfmVxfC2agCTyjA7oWp9TrZIMeta } from "/tmp/build_847345ee/pages/admin/index.vue?macro=true";
import { default as indexev52_45H4wSFv7DEFbVLqIC9hSoBR1qWM4L6aQl9HGNtAMeta } from "/tmp/build_847345ee/pages/app/hangout/index.vue?macro=true";
import { default as agendaQ6f7MIC7KqSCOxrZk8OeRdU0Fe6Vu9jH98VmwAlQdR0Meta } from "/tmp/build_847345ee/pages/app/hangout/agenda.vue?macro=true";
import { default as meetupshLq7Nlb3USptRL7a1xATWdio1_brYNGq7PiNx_45yNv4IMeta } from "/tmp/build_847345ee/pages/app/hangout/meetups.vue?macro=true";
import { default as organize3SwCD_wAMI9JooHLVYvP6EKngoVUDR3C_45gl8kqOjHtIMeta } from "/tmp/build_847345ee/pages/app/hangout/organize.vue?macro=true";
import { default as hangout4dBiZzb2Mb2eGQJPVbZXPIzZy4s_HMOtEJQI6ftW4rYMeta } from "/tmp/build_847345ee/pages/app/hangout.vue?macro=true";
import { default as charte1IxgDL5pC0hVCdnkFtcSz8jNlWKhXXJfLlsUBqLGsD8Meta } from "/tmp/build_847345ee/pages/main/charte.vue?macro=true";
import { default as francexGgQXLDiCnD3q8maUPQsmoUhwV4aOewS5XEPgsjjINIMeta } from "/tmp/build_847345ee/pages/main/france.vue?macro=true";
import { default as themes0Rdmls73SPfSpNLftxN0hPTPAxCfzZrecH8BqIaV47EMeta } from "/tmp/build_847345ee/pages/admin/themes.vue?macro=true";
import { default as indexcVoA43VRwTA7m_ZqmuML3EjtTsbRZlltSmcqLnCQ5gcMeta } from "/tmp/build_847345ee/pages/app/insiders/index.vue?macro=true";
import { default as suggestionsM5HTIOHkL0N9HEZZ2pcCaH2IC_45pYYbI6O1ZEzt2MqbwMeta } from "/tmp/build_847345ee/pages/app/insiders/suggestions.vue?macro=true";
import { default as insidersNHshH3x9vbjD5e35pNShayRAf_cL9_kPsN4TEM9fsmcMeta } from "/tmp/build_847345ee/pages/app/insiders.vue?macro=true";
import { default as messagesW8_455xo9rvLSAqoTYnmMHXMaFWa5IvgaFilFiBCIIqzUMeta } from "/tmp/build_847345ee/pages/app/messages.vue?macro=true";
import { default as privacyz_a4mgUtzvGmnpwM_SSXtV5X7T06dDxXKxufooFdB1IMeta } from "/tmp/build_847345ee/pages/main/privacy.vue?macro=true";
import { default as trainereyrZSj7ghbBdK2Lmta8SbpPBVBBrB9O2rc_45GxkZvKvAMeta } from "/tmp/build_847345ee/pages/admin/trainer.vue?macro=true";
import { default as indexA8aRNqiL_T9LQr7938bLzoxxL8jgckfA8RkJs6Duy34Meta } from "/tmp/build_847345ee/pages/app/community/index.vue?macro=true";
import { default as searchKBp_45jNg464Ixum_KcdYeeHkzFj37pNsaov5Yla1UHEYMeta } from "/tmp/build_847345ee/pages/app/community/search.vue?macro=true";
import { default as bestiesOExnq2WmsVMaBS1ihxVbZFjWtX3ohVWvaYWBNYuTbasMeta } from "/tmp/build_847345ee/pages/app/community/besties.vue?macro=true";
import { default as index_Rp2STU_JSdHkSAQQJvZqjcwjc6CupCBwQFpFczP_G0Meta } from "/tmp/build_847345ee/pages/app/community/[type]/index.vue?macro=true";
import { default as communityZnlCDsMhtQ6tsd8_45bP8tkQ24oPqiw76qatpRBeJhbUEMeta } from "/tmp/build_847345ee/pages/app/community.vue?macro=true";
import { default as indexxG2iOOL0F7KSMT60u8OOKheF0AL4VVEnhrH_45Spcl340Meta } from "/tmp/build_847345ee/pages/app/auth/index.vue?macro=true";
import { default as aboutsxT7G6tWcy7bc79p6STSq3MfLNhdlEUc3et05Lkl5rQMeta } from "/tmp/build_847345ee/pages/app/onboarding/about.vue?macro=true";
import { default as emailcHqTtNdTwCh2q8ndTtbv0LyQZuFinDLFE6F6t2IBp_UMeta } from "/tmp/build_847345ee/pages/app/onboarding/email.vue?macro=true";
import { default as goalsUVzskxgMBbsKdJFGy0_yDFXTRxjFgtxzdBglqHPRn64Meta } from "/tmp/build_847345ee/pages/app/onboarding/goals.vue?macro=true";
import { default as index6MrlwcjlhjZq0PWYAsnjNKl6xgaUt5ecnjlAiQnkhHwMeta } from "/tmp/build_847345ee/pages/app/onboarding/index.vue?macro=true";
import { default as phone5w4RlGnb82wa4YC_R88coZmy9GcyU3Bw9kiW0kjasy4Meta } from "/tmp/build_847345ee/pages/app/onboarding/phone.vue?macro=true";
import { default as groupsM04LMZhmlPluHdT_45jfkv8DFaZdrfx0YAClAplNPQdZoMeta } from "/tmp/build_847345ee/pages/app/onboarding/groups.vue?macro=true";
import { default as search0pt234aS7K0aPqRuHPkv_451_45EIDV8oDrFBTUU217dmoEMeta } from "/tmp/build_847345ee/pages/app/onboarding/search.vue?macro=true";
import { default as charterfgrf3JC1sICuCbax1Bc8_45wzkEcl3f4Sd_45w9PUuBg0yoMeta } from "/tmp/build_847345ee/pages/app/onboarding/charter.vue?macro=true";
import { default as loadingtvtILen3_2rRN263ZsRZq7mZ8FdeD6ZGdWDfynmwBYMMeta } from "/tmp/build_847345ee/pages/app/onboarding/loading.vue?macro=true";
import { default as profileDBbcICW29_45WN21akDkL1Vnbu9ocLKfR6jWBvO3ursxQMeta } from "/tmp/build_847345ee/pages/app/onboarding/profile.vue?macro=true";
import { default as identityFEbgeFqlZaGTiKdx2aO1KVJX66va7gAQ32nt1TAnms0Meta } from "/tmp/build_847345ee/pages/app/onboarding/identity.vue?macro=true";
import { default as profiles5CegM3I_87JZAHBeG9iaKMXx598MZOptGn6At4FUqgIMeta } from "/tmp/build_847345ee/pages/app/onboarding/profiles.vue?macro=true";
import { default as membershipiPciYR9LpCU4qPvWvct3v7fV1qmvgI8rZLffcJJLyu0Meta } from "/tmp/build_847345ee/pages/app/onboarding/membership.vue?macro=true";
import { default as permissionsBBLkn_45YmU2fKuX0uTiTsWEace286BS9dqJ47RYUnF7QMeta } from "/tmp/build_847345ee/pages/app/onboarding/permissions.vue?macro=true";
import { default as onboardingP4ZphTYr1xACZ_k5KN5NfDNYEesOUyMVZDMv4rAgKs8Meta } from "/tmp/build_847345ee/pages/app/onboarding.vue?macro=true";
import { default as investorsMjvdVZrIyas8I8mrfBOlSMiJ_nWcjuqoPidwzKS76iwMeta } from "/tmp/build_847345ee/pages/main/investors.vue?macro=true";
import { default as _91id_93qmHkJVTp5DK4PY2Tnch6Zjg3CTHgcl826elFC_grznwMeta } from "/tmp/build_847345ee/pages/admin/blog/[id].vue?macro=true";
import { default as broadcastiwDZNstIprzzgt_3P1O8zLLPZfW45kc1Qj92T_45EmzAsMeta } from "/tmp/build_847345ee/pages/admin/broadcast.vue?macro=true";
import { default as delete1AeZ_45LGKBnnkgFquGbZ__xgjcwxPOmknU87dViBdIw4Meta } from "/tmp/build_847345ee/pages/app/auth/delete.vue?macro=true";
import { default as logoutTN0eTG1_45iz5pHJxaKosQmbJBIuTHFqnoZW5aE47gMgoMeta } from "/tmp/build_847345ee/pages/app/auth/logout.vue?macro=true";
import { default as indexUrbYvd1bJcy1hKmQv_UdQCL7MgZvCY_FUEttR9WyeQgMeta } from "/tmp/build_847345ee/pages/app/story/index.vue?macro=true";
import { default as indexftlAuxFtErt5m_ZqPEvmIz3fb7g23mv1xBWnO_45zl634Meta } from "/tmp/build_847345ee/pages/backstage/index.vue?macro=true";
import { default as indexypT4eXfTiv_45SXZeT4IzqLT__EhhBVTaJ5aHDPt6MljUMeta } from "/tmp/build_847345ee/pages/main/auth/index.vue?macro=true";
import { default as index5_hcx4q1kJ8pgcc29ZRZcAPbMXslpbxKWxt2tpWp2kAMeta } from "/tmp/build_847345ee/pages/main/blog/index.vue?macro=true";
import { default as indexL5Qr4DjJQvuIEqg2SerjIHyynHnnpGAjRg7y_aut__45gMeta } from "/tmp/build_847345ee/pages/admin/auth/index.vue?macro=true";
import { default as indexdEe3eUPJ3ikubhTLNcr6kBlEQwMMbftplxnyroRAwVIMeta } from "/tmp/build_847345ee/pages/admin/blog/index.vue?macro=true";
import { default as deleteo2gZ9nYV1fM4uMlsj8oD5qsbb3waA7u5sQULtbSrKwMMeta } from "/tmp/build_847345ee/pages/main/auth/delete.vue?macro=true";
import { default as _91slug_93rNJ3ugU6TVxjdUgRQgU4WQnS_iyjm60ZGCOaDfjjbJ0Meta } from "/tmp/build_847345ee/pages/main/blog/[slug].vue?macro=true";
import { default as indexZGNPOKvzFRobGzqXQ888yZTq_45etq_45htL8wck7yKpIQgMeta } from "/tmp/build_847345ee/pages/main/event/index.vue?macro=true";
import { default as _91token_93G3WVLWBUFdxV90STIvSqm2l9rbUZs41Lmg_45rzI1aurUMeta } from "/tmp/build_847345ee/pages/payments/[token].vue?macro=true";
import { default as editsgAqvFEFOJOzrpWn42qWR8DSHDUr3m_45nqJvOdgiSCuYMeta } from "/tmp/build_847345ee/pages/app/events/[slug]/edit.vue?macro=true";
import { default as indexGg2Rh9EpuBqSrc_zI5sT7vlxRtuq3Jpq_45y_Z9mRx3RYMeta } from "/tmp/build_847345ee/pages/app/events/[slug]/index.vue?macro=true";
import { default as _91slug_93gVaBdtQITbbx5tHBa7OZkOZljLT6S_45mQLv_Iw8HhphMMeta } from "/tmp/build_847345ee/pages/app/events/[slug].vue?macro=true";
import { default as create45d6dBmfnIKjd6RHkpYgGnGJueXeNYLd6IAAX5tWWS8Meta } from "/tmp/build_847345ee/pages/app/events/create.vue?macro=true";
import { default as list3DnN5zzVdIaLHWAg8MCAL_t5qJUnKbNEhWE2vYdmwvIMeta } from "/tmp/build_847345ee/pages/app/partners/list.vue?macro=true";
import { default as _91slug_935GnfctpxXJG3Q7WrH0R85O_NnArzeYGarfNAXlv3kK8Meta } from "/tmp/build_847345ee/pages/main/event/[slug].vue?macro=true";
import { default as _91slug_93gxg2eaCplx675GRCx3BJNdvkGRUJoINQmnCYuU52y6cMeta } from "/tmp/build_847345ee/pages/main/group/[slug].vue?macro=true";
import { default as _91slug_938jVAMjno1uFpMFMQXMQzRKE6Q2aiQCcAndLvf_NoJSYMeta } from "/tmp/build_847345ee/pages/main/place/[slug].vue?macro=true";
import { default as _91city_93aiCXiQxcWtSAnFkq_455aJ2UF37u_450Q1Qz0lcz4_45z44QwMeta } from "/tmp/build_847345ee/pages/main/cities/[city].vue?macro=true";
import { default as _91slug_93stnUWun5l3F15HMQtybFcC4go_mEmR3MZbTn7Ue69U0Meta } from "/tmp/build_847345ee/pages/main/invite/[slug].vue?macro=true";
import { default as organizationskF8bb18y1XKOZhK7Lr_45wAJfoBElGUyHzlMv_45OoVP6oYMeta } from "/tmp/build_847345ee/pages/admin/organizations.vue?macro=true";
import { default as indexbxynXC4thrH3lrWJbamtow960GrcaReN4IZyteO919UMeta } from "/tmp/build_847345ee/pages/admin/reports/index.vue?macro=true";
import { default as eventsQDW02vN_45U6cHawPeCow49ltg5dR0UYP4h0iG3c_8AxAMeta } from "/tmp/build_847345ee/pages/admin/reports/events.vue?macro=true";
import { default as preferenceskKI9EPyanis_Jsgl0meJvgS_P7fc69Qjv_F7pmVp0LQMeta } from "/tmp/build_847345ee/pages/app/auth/preferences.vue?macro=true";
import { default as loginI476OGvr0MPPqNMa9YIo4WBafOPHfrBl_45UuQ30WOn_4Meta } from "/tmp/build_847345ee/pages/backstage/auth/login.vue?macro=true";
import { default as _91id_93UvP0oKZDFhe7U_45i_z6t11vwtOY1vVxB1E1dqKQXn_45s4Meta } from "/tmp/build_847345ee/pages/app/conversation/[id].vue?macro=true";
import { default as logoutQfrygLLiGnLLpyksnx_y0FGHj9BPXH_FB3o7LwSNJpwMeta } from "/tmp/build_847345ee/pages/backstage/auth/logout.vue?macro=true";
import { default as preferencesUvJL_45VKV2yk5GHLTCGZSfC15onEsa9l2cabIumkLbhMMeta } from "/tmp/build_847345ee/pages/main/auth/preferences.vue?macro=true";
import { default as listuHCNClRkTWYG2gzq3Jctp3KHKJJM4PeynGiKxUs1KWYMeta } from "/tmp/build_847345ee/pages/app/organizations/list.vue?macro=true";
import { default as _91token_93obd_y87VMj4L0kWiA6HtM3ndnWRPVzz1WTep_45a6IfrEMeta } from "/tmp/build_847345ee/pages/app/auth/verify/[token].vue?macro=true";
import { default as register46t0bNdvUtgX1IVTsDfchCl8j1sKKzcEAGhCC3cr6UcMeta } from "/tmp/build_847345ee/pages/backstage/auth/register.vue?macro=true";
import { default as _91code_93Hw3vx0wQAG9Zkxq3Ja5O_C2MYs7P5D7zdK8__ML9uwcMeta } from "/tmp/build_847345ee/pages/backstage/invite/[code].vue?macro=true";
import { default as discord2Hjkrd2sjGpJEifu_45tDtH2ZD_45JXfuU3_45y9wNfQsnEBQMeta } from "/tmp/build_847345ee/pages/app/integrations/discord.vue?macro=true";
import { default as indexyv0bikET0j2CB_mDpnqLksLBsfyIUhrWuEBfKf7gtqIMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/index.vue?macro=true";
import { default as questions_45frequentes2wlAme0fByQxTn3YAbLPo6QL_453J9S6r9ziQ4AKvol9AMeta } from "/tmp/build_847345ee/pages/main/questions-frequentes.vue?macro=true";
import { default as discord_45auth4z8d0e__45I1C4YS2FIxCgd8324bZkrxsAPNNYBA0FOywMeta } from "/tmp/build_847345ee/pages/app/integrations/discord-auth.vue?macro=true";
import { default as subscriberpEDUNUPVYmEqB5Ep9ReYQBh43TMilnXMjCakaRhNnUMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/subscribe.vue?macro=true";
import { default as indexs0qLxuRgu7_k8_2VLy6drTIb724OhezxErtozlcVatUMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/events/index.vue?macro=true";
import { default as index8nOcIazOrF6vDgg3jvoPOOmnz5yGrH4jdfhfKpjSqJsMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/places/index.vue?macro=true";
import { default as index6z_45jt0rqzO_456_u_fC8rYY8_45ke1yAZOYpXCNwUKUL7O4Meta } from "/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/edit/index.vue?macro=true";
import { default as details4uR011v6wst0eTPuLqTx2jkhrzx6KqfAkd0Mp3KU4VwMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/edit/details.vue?macro=true";
import { default as advancedTpbOYAQi5yTF80DM8d_45rr7_45pUarL3zWq5Qs5EZS1XXgMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/edit/advanced.vue?macro=true";
import { default as attendeeszElQXPvu_r9B5LfyI8_NAHZ9a_qfEV8UmGklOMF1eAQMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/edit/attendees.vue?macro=true";
import { default as edit9d3vqlQA8kpD2zOOSo1fOtZ_0ir5Mx5xwIXw0twV4twMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/edit.vue?macro=true";
import { default as indexFDz_45Pq6mzIJ_45vr5Pt9nZj0dorlHc_vJ9wEjRsXUMRvIMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/index.vue?macro=true";
import { default as attendeesnVVI1Mt0hH_d_CV3EYaqs2z_453BriqgbtfcWRsKJioPkMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/attendees.vue?macro=true";
import { default as _91slug_93Z2WSEC9oq5hwjkt3UoQArTfbbwzbTkNZgfynLJ2gy_wMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/events/[slug].vue?macro=true";
import { default as create4d73hejedQkaHecom5p53BOEzmPyjdO8puRuJk8ikMEMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/events/create.vue?macro=true";
import { default as index_453kRYBO__Pw2utcio_45eLlUnwRYuBoEwtqnpnPRyyIvwMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/settings/index.vue?macro=true";
import { default as indexczv_CQgOe9I_LpQbhWN7pkISCMwsWgbEKDt_JQuti1wMeta } from "/tmp/build_847345ee/pages/backstage/dashboard/organization/index.vue?macro=true";
import { default as component_45stub32_45B619_45qLik9Dit1RzctRZFqRO7e8r9OPlwhREQD2EMeta } from "/tmp/build_847345ee/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub32_45B619_45qLik9Dit1RzctRZFqRO7e8r9OPlwhREQD2E } from "/tmp/build_847345ee/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: meDxWqzKY51H4C5P2OehYTCCw4l8_3C08xHGzcW_45ravJoMeta?.name,
    path: "/app/me",
    meta: meDxWqzKY51H4C5P2OehYTCCw4l8_3C08xHGzcW_45ravJoMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/me.vue"),
    children: [
  {
    name: "app-me",
    path: "",
    component: () => import("/tmp/build_847345ee/pages/app/me/index.vue")
  }
]
  },
  {
    name: "app-map",
    path: "/app/map",
    meta: { ...(mapX5qKEBh7Lvff1VFLeXAFs3_eOpUeBXhrH_45Y4dcZn9M0Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/map.vue")
  },
  {
    name: feedSeVcC4KYwgKSTdGJE6NbRGBpm_45DlK0jqoK4CStDhnIEMeta?.name,
    path: "/app/feed",
    meta: { ...(feedSeVcC4KYwgKSTdGJE6NbRGBpm_45DlK0jqoK4CStDhnIEMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/feed.vue"),
    children: [
  {
    name: "app-feed-post",
    path: "post",
    meta: post7o97b7_45c4mSOxLtUGH1h3XgyKt4HiQc_45QlPkYMlV6_4Meta || {},
    component: () => import("/tmp/build_847345ee/pages/app/feed/post.vue")
  },
  {
    name: "app-feed",
    path: "",
    meta: indexaaf2etMhWwpptohDr_453S7VCGqqUtG8qzKDhAzfEJ_H8Meta || {},
    component: () => import("/tmp/build_847345ee/pages/app/feed/index.vue")
  },
  {
    name: "app-feed-type",
    path: ":type()",
    meta: _91type_934Dwdq87YCVehhoH_45liZigNC0P_45CnOzHBUHnrtvDOLdQMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/feed/[type].vue")
  }
]
  },
  {
    name: "app",
    path: "/app",
    meta: { ...(indexEz9iaK2LToV2IhcF0ED5w2DJZEpoilwSMGsLS4g_45_45PQMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/index.vue")
  },
  {
    name: "main-eula",
    path: "/main/eula",
    meta: eulaWtccuKlG8o1Y9mMGNbxT5z7MXBQk_45ma7f7XiiTqEE1UMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/eula.vue")
  },
  {
    name: groupsAM8a0nYmFzhB8Kgwjz93SkrCUaowiKtYgekQXhKNrNkMeta?.name,
    path: "/app/groups",
    meta: { ...(groupsAM8a0nYmFzhB8Kgwjz93SkrCUaowiKtYgekQXhKNrNkMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/groups.vue"),
    children: [
  {
    name: "app-groups",
    path: "",
    component: () => import("/tmp/build_847345ee/pages/app/groups/index.vue")
  },
  {
    name: _91slug_93EfaMJaQZSghK3O5KRazaEPaBCL_QIbZ7VdboW9uuvwcMeta?.name,
    path: ":slug()",
    meta: _91slug_93EfaMJaQZSghK3O5KRazaEPaBCL_QIbZ7VdboW9uuvwcMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/groups/[slug].vue"),
    children: [
  {
    name: "app-groups-slug-edit",
    path: "edit",
    component: () => import("/tmp/build_847345ee/pages/app/groups/[slug]/edit.vue")
  },
  {
    name: "app-groups-slug-about",
    path: "about",
    component: () => import("/tmp/build_847345ee/pages/app/groups/[slug]/about.vue")
  },
  {
    name: "app-groups-slug",
    path: "",
    component: () => import("/tmp/build_847345ee/pages/app/groups/[slug]/index.vue")
  },
  {
    name: "app-groups-slug-events",
    path: "events",
    component: () => import("/tmp/build_847345ee/pages/app/groups/[slug]/events.vue")
  },
  {
    name: "app-groups-slug-members",
    path: "members",
    component: () => import("/tmp/build_847345ee/pages/app/groups/[slug]/members.vue")
  },
  {
    name: "app-groups-slug-conversations",
    path: "conversations",
    component: () => import("/tmp/build_847345ee/pages/app/groups/[slug]/conversations.vue")
  }
]
  },
  {
    name: "app-groups-create",
    path: "create",
    meta: createmcKzQe03ux01fVmMm_45YGWTbKcw0yi_c3cgwrwLCKbAEMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/groups/create.vue")
  }
]
  },
  {
    name: paramsv92FLnDMF_458iBXPSkOcqqJrVwAXAEKt3Jy59Ji9kFrAMeta?.name,
    path: "/app/params",
    meta: { ...(paramsv92FLnDMF_458iBXPSkOcqqJrVwAXAEKt3Jy59Ji9kFrAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/params.vue"),
    children: [
  {
    name: "app-params",
    path: "",
    meta: { ...(indexYYo9pj2EAkrmagVoP0iN_45OyVdLsvwbHUbtzjBYKPgQcMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/params/index.vue")
  },
  {
    name: "app-params-account",
    path: "account",
    meta: { ...(accountPmXaOoOGZkEvXdGl_LXcfIHQez9dzynJdSpX5uMPnl8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/params/account.vue")
  },
  {
    name: "app-params-transactions",
    path: "transactions",
    meta: { ...(transactionsH7AfTiWw4baDLFTr4mFmaD_45D8KSXTjylp5FEhE28oDwMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/params/transactions.vue")
  }
]
  },
  {
    name: "main",
    path: "/main",
    meta: index0yfs3znmcdd5z6uG0XpaGfWMyPb3gk_45RGrLrVYLv3EkMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/index.vue")
  },
  {
    name: "main-press",
    path: "/main/press",
    meta: press1njoSVCAVG2tnyPHDiZzwx0Hq8UAVOljPqlEMUFX3ZQMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/press.vue")
  },
  {
    name: "admin-codes",
    path: "/admin/codes",
    meta: { ...(codesqomOj9Tsag6qA0RFI2_45AQLh4b9VHasGSsgvGX1y_45MQkMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_847345ee/pages/admin/codes.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(index1FZk7mAEXGB9gOqsysdDfmVxfC2agCTyjA7oWp9TrZIMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_847345ee/pages/admin/index.vue")
  },
  {
    name: hangout4dBiZzb2Mb2eGQJPVbZXPIzZy4s_HMOtEJQI6ftW4rYMeta?.name,
    path: "/app/hangout",
    meta: { ...(hangout4dBiZzb2Mb2eGQJPVbZXPIzZy4s_HMOtEJQI6ftW4rYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/hangout.vue"),
    children: [
  {
    name: "app-hangout",
    path: "",
    meta: indexev52_45H4wSFv7DEFbVLqIC9hSoBR1qWM4L6aQl9HGNtAMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/hangout/index.vue")
  },
  {
    name: "app-hangout-agenda",
    path: "agenda",
    meta: { ...(agendaQ6f7MIC7KqSCOxrZk8OeRdU0Fe6Vu9jH98VmwAlQdR0Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/hangout/agenda.vue")
  },
  {
    name: "app-hangout-meetups",
    path: "meetups",
    meta: meetupshLq7Nlb3USptRL7a1xATWdio1_brYNGq7PiNx_45yNv4IMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/hangout/meetups.vue")
  },
  {
    name: "app-hangout-organize",
    path: "organize",
    meta: { ...(organize3SwCD_wAMI9JooHLVYvP6EKngoVUDR3C_45gl8kqOjHtIMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/hangout/organize.vue")
  }
]
  },
  {
    name: "main-charte",
    path: "/main/charte",
    meta: charte1IxgDL5pC0hVCdnkFtcSz8jNlWKhXXJfLlsUBqLGsD8Meta || {},
    component: () => import("/tmp/build_847345ee/pages/main/charte.vue")
  },
  {
    name: "main-france",
    path: "/main/france",
    meta: francexGgQXLDiCnD3q8maUPQsmoUhwV4aOewS5XEPgsjjINIMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/france.vue")
  },
  {
    name: "admin-themes",
    path: "/admin/themes",
    meta: { ...(themes0Rdmls73SPfSpNLftxN0hPTPAxCfzZrecH8BqIaV47EMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_847345ee/pages/admin/themes.vue")
  },
  {
    name: insidersNHshH3x9vbjD5e35pNShayRAf_cL9_kPsN4TEM9fsmcMeta?.name,
    path: "/app/insiders",
    meta: { ...(insidersNHshH3x9vbjD5e35pNShayRAf_cL9_kPsN4TEM9fsmcMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/insiders.vue"),
    children: [
  {
    name: "app-insiders",
    path: "",
    component: () => import("/tmp/build_847345ee/pages/app/insiders/index.vue")
  },
  {
    name: "app-insiders-suggestions",
    path: "suggestions",
    meta: suggestionsM5HTIOHkL0N9HEZZ2pcCaH2IC_45pYYbI6O1ZEzt2MqbwMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/insiders/suggestions.vue")
  }
]
  },
  {
    name: "app-messages",
    path: "/app/messages",
    meta: { ...(messagesW8_455xo9rvLSAqoTYnmMHXMaFWa5IvgaFilFiBCIIqzUMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/messages.vue")
  },
  {
    name: "main-privacy",
    path: "/main/privacy",
    meta: privacyz_a4mgUtzvGmnpwM_SSXtV5X7T06dDxXKxufooFdB1IMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/privacy.vue")
  },
  {
    name: "admin-trainer",
    path: "/admin/trainer",
    meta: { ...(trainereyrZSj7ghbBdK2Lmta8SbpPBVBBrB9O2rc_45GxkZvKvAMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_847345ee/pages/admin/trainer.vue")
  },
  {
    name: communityZnlCDsMhtQ6tsd8_45bP8tkQ24oPqiw76qatpRBeJhbUEMeta?.name,
    path: "/app/community",
    meta: { ...(communityZnlCDsMhtQ6tsd8_45bP8tkQ24oPqiw76qatpRBeJhbUEMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/community.vue"),
    children: [
  {
    name: "app-community",
    path: "",
    meta: indexA8aRNqiL_T9LQr7938bLzoxxL8jgckfA8RkJs6Duy34Meta || {},
    component: () => import("/tmp/build_847345ee/pages/app/community/index.vue")
  },
  {
    name: "app-community-search",
    path: "search",
    meta: searchKBp_45jNg464Ixum_KcdYeeHkzFj37pNsaov5Yla1UHEYMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/community/search.vue")
  },
  {
    name: "app-community-besties",
    path: "besties",
    meta: { ...(bestiesOExnq2WmsVMaBS1ihxVbZFjWtX3ohVWvaYWBNYuTbasMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/community/besties.vue")
  },
  {
    name: "app-community-type",
    path: ":type()",
    meta: { ...(index_Rp2STU_JSdHkSAQQJvZqjcwjc6CupCBwQFpFczP_G0Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/community/[type]/index.vue")
  }
]
  },
  {
    name: "app-auth",
    path: "/app/auth",
    meta: { ...(indexxG2iOOL0F7KSMT60u8OOKheF0AL4VVEnhrH_45Spcl340Meta || {}), ...{"middleware":["is-not-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/auth/index.vue")
  },
  {
    name: onboardingP4ZphTYr1xACZ_k5KN5NfDNYEesOUyMVZDMv4rAgKs8Meta?.name,
    path: "/app/onboarding",
    meta: { ...(onboardingP4ZphTYr1xACZ_k5KN5NfDNYEesOUyMVZDMv4rAgKs8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/onboarding.vue"),
    children: [
  {
    name: "app-onboarding-about",
    path: "about",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/about.vue")
  },
  {
    name: "app-onboarding-email",
    path: "email",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/email.vue")
  },
  {
    name: "app-onboarding-goals",
    path: "goals",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/goals.vue")
  },
  {
    name: "app-onboarding",
    path: "",
    meta: index6MrlwcjlhjZq0PWYAsnjNKl6xgaUt5ecnjlAiQnkhHwMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/index.vue")
  },
  {
    name: "app-onboarding-phone",
    path: "phone",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/phone.vue")
  },
  {
    name: "app-onboarding-groups",
    path: "groups",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/groups.vue")
  },
  {
    name: "app-onboarding-search",
    path: "search",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/search.vue")
  },
  {
    name: "app-onboarding-charter",
    path: "charter",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/charter.vue")
  },
  {
    name: "app-onboarding-loading",
    path: "loading",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/loading.vue")
  },
  {
    name: "app-onboarding-profile",
    path: "profile",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/profile.vue")
  },
  {
    name: "app-onboarding-identity",
    path: "identity",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/identity.vue")
  },
  {
    name: "app-onboarding-profiles",
    path: "profiles",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/profiles.vue")
  },
  {
    name: "app-onboarding-membership",
    path: "membership",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/membership.vue")
  },
  {
    name: "app-onboarding-permissions",
    path: "permissions",
    component: () => import("/tmp/build_847345ee/pages/app/onboarding/permissions.vue")
  }
]
  },
  {
    name: "main-investors",
    path: "/main/investors",
    meta: investorsMjvdVZrIyas8I8mrfBOlSMiJ_nWcjuqoPidwzKS76iwMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/investors.vue")
  },
  {
    name: "admin-blog-id",
    path: "/admin/blog/:id()",
    meta: { ...(_91id_93qmHkJVTp5DK4PY2Tnch6Zjg3CTHgcl826elFC_grznwMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_847345ee/pages/admin/blog/[id].vue")
  },
  {
    name: "admin-broadcast",
    path: "/admin/broadcast",
    meta: { ...(broadcastiwDZNstIprzzgt_3P1O8zLLPZfW45kc1Qj92T_45EmzAsMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_847345ee/pages/admin/broadcast.vue")
  },
  {
    name: "app-auth-delete",
    path: "/app/auth/delete",
    meta: delete1AeZ_45LGKBnnkgFquGbZ__xgjcwxPOmknU87dViBdIw4Meta || {},
    component: () => import("/tmp/build_847345ee/pages/app/auth/delete.vue")
  },
  {
    name: "app-auth-logout",
    path: "/app/auth/logout",
    meta: logoutTN0eTG1_45iz5pHJxaKosQmbJBIuTHFqnoZW5aE47gMgoMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/auth/logout.vue")
  },
  {
    name: "app-story",
    path: "/app/story",
    meta: { ...(indexUrbYvd1bJcy1hKmQv_UdQCL7MgZvCY_FUEttR9WyeQgMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/story/index.vue")
  },
  {
    name: "backstage",
    path: "/backstage",
    meta: { ...(indexftlAuxFtErt5m_ZqPEvmIz3fb7g23mv1xBWnO_45zl634Meta || {}), ...{"middleware":["backstage-auth"]} },
    component: () => import("/tmp/build_847345ee/pages/backstage/index.vue")
  },
  {
    name: "main-auth",
    path: "/main/auth",
    component: () => import("/tmp/build_847345ee/pages/main/auth/index.vue")
  },
  {
    name: "main-blog",
    path: "/main/blog",
    meta: index5_hcx4q1kJ8pgcc29ZRZcAPbMXslpbxKWxt2tpWp2kAMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/blog/index.vue")
  },
  {
    name: "admin-auth",
    path: "/admin/auth",
    meta: indexL5Qr4DjJQvuIEqg2SerjIHyynHnnpGAjRg7y_aut__45gMeta || {},
    component: () => import("/tmp/build_847345ee/pages/admin/auth/index.vue")
  },
  {
    name: "admin-blog",
    path: "/admin/blog",
    meta: { ...(indexdEe3eUPJ3ikubhTLNcr6kBlEQwMMbftplxnyroRAwVIMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_847345ee/pages/admin/blog/index.vue")
  },
  {
    name: "main-auth-delete",
    path: "/main/auth/delete",
    component: () => import("/tmp/build_847345ee/pages/main/auth/delete.vue")
  },
  {
    name: "main-blog-slug",
    path: "/main/blog/:slug()",
    meta: _91slug_93rNJ3ugU6TVxjdUgRQgU4WQnS_iyjm60ZGCOaDfjjbJ0Meta || {},
    component: () => import("/tmp/build_847345ee/pages/main/blog/[slug].vue")
  },
  {
    name: "main-event",
    path: "/main/event",
    meta: indexZGNPOKvzFRobGzqXQ888yZTq_45etq_45htL8wck7yKpIQgMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/event/index.vue")
  },
  {
    name: "payments-token",
    path: "/payments/:token()",
    meta: _91token_93G3WVLWBUFdxV90STIvSqm2l9rbUZs41Lmg_45rzI1aurUMeta || {},
    component: () => import("/tmp/build_847345ee/pages/payments/[token].vue")
  },
  {
    name: _91slug_93gVaBdtQITbbx5tHBa7OZkOZljLT6S_45mQLv_Iw8HhphMMeta?.name,
    path: "/app/events/:slug()",
    meta: { ...(_91slug_93gVaBdtQITbbx5tHBa7OZkOZljLT6S_45mQLv_Iw8HhphMMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/events/[slug].vue"),
    children: [
  {
    name: "app-events-slug-edit",
    path: "edit",
    meta: editsgAqvFEFOJOzrpWn42qWR8DSHDUr3m_45nqJvOdgiSCuYMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/events/[slug]/edit.vue")
  },
  {
    name: "app-events-slug",
    path: "",
    component: () => import("/tmp/build_847345ee/pages/app/events/[slug]/index.vue")
  }
]
  },
  {
    name: "app-events-create",
    path: "/app/events/create",
    meta: { ...(create45d6dBmfnIKjd6RHkpYgGnGJueXeNYLd6IAAX5tWWS8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/events/create.vue")
  },
  {
    name: "app-partners-list",
    path: "/app/partners/list",
    meta: { ...(list3DnN5zzVdIaLHWAg8MCAL_t5qJUnKbNEhWE2vYdmwvIMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/partners/list.vue")
  },
  {
    name: "main-event-slug",
    path: "/main/event/:slug()",
    meta: _91slug_935GnfctpxXJG3Q7WrH0R85O_NnArzeYGarfNAXlv3kK8Meta || {},
    component: () => import("/tmp/build_847345ee/pages/main/event/[slug].vue")
  },
  {
    name: "main-group-slug",
    path: "/main/group/:slug()",
    meta: _91slug_93gxg2eaCplx675GRCx3BJNdvkGRUJoINQmnCYuU52y6cMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/group/[slug].vue")
  },
  {
    name: "main-place-slug",
    path: "/main/place/:slug()",
    meta: _91slug_938jVAMjno1uFpMFMQXMQzRKE6Q2aiQCcAndLvf_NoJSYMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/place/[slug].vue")
  },
  {
    name: "main-cities-city",
    path: "/main/cities/:city()",
    meta: _91city_93aiCXiQxcWtSAnFkq_455aJ2UF37u_450Q1Qz0lcz4_45z44QwMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/cities/[city].vue")
  },
  {
    name: "main-invite-slug",
    path: "/main/invite/:slug()",
    component: () => import("/tmp/build_847345ee/pages/main/invite/[slug].vue")
  },
  {
    name: "admin-organizations",
    path: "/admin/organizations",
    meta: { ...(organizationskF8bb18y1XKOZhK7Lr_45wAJfoBElGUyHzlMv_45OoVP6oYMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_847345ee/pages/admin/organizations.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    meta: { ...(indexbxynXC4thrH3lrWJbamtow960GrcaReN4IZyteO919UMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_847345ee/pages/admin/reports/index.vue")
  },
  {
    name: "admin-reports-events",
    path: "/admin/reports/events",
    meta: { ...(eventsQDW02vN_45U6cHawPeCow49ltg5dR0UYP4h0iG3c_8AxAMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_847345ee/pages/admin/reports/events.vue")
  },
  {
    name: "app-auth-preferences",
    path: "/app/auth/preferences",
    meta: preferenceskKI9EPyanis_Jsgl0meJvgS_P7fc69Qjv_F7pmVp0LQMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/auth/preferences.vue")
  },
  {
    name: "backstage-auth-login",
    path: "/backstage/auth/login",
    meta: loginI476OGvr0MPPqNMa9YIo4WBafOPHfrBl_45UuQ30WOn_4Meta || {},
    component: () => import("/tmp/build_847345ee/pages/backstage/auth/login.vue")
  },
  {
    name: "app-conversation-id",
    path: "/app/conversation/:id()",
    meta: { ...(_91id_93UvP0oKZDFhe7U_45i_z6t11vwtOY1vVxB1E1dqKQXn_45s4Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/conversation/[id].vue")
  },
  {
    name: "backstage-auth-logout",
    path: "/backstage/auth/logout",
    meta: logoutQfrygLLiGnLLpyksnx_y0FGHj9BPXH_FB3o7LwSNJpwMeta || {},
    component: () => import("/tmp/build_847345ee/pages/backstage/auth/logout.vue")
  },
  {
    name: "main-auth-preferences",
    path: "/main/auth/preferences",
    component: () => import("/tmp/build_847345ee/pages/main/auth/preferences.vue")
  },
  {
    name: "app-organizations-list",
    path: "/app/organizations/list",
    meta: { ...(listuHCNClRkTWYG2gzq3Jctp3KHKJJM4PeynGiKxUs1KWYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/app/organizations/list.vue")
  },
  {
    name: "app-auth-verify-token",
    path: "/app/auth/verify/:token()",
    meta: _91token_93obd_y87VMj4L0kWiA6HtM3ndnWRPVzz1WTep_45a6IfrEMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/auth/verify/[token].vue")
  },
  {
    name: "backstage-auth-register",
    path: "/backstage/auth/register",
    meta: register46t0bNdvUtgX1IVTsDfchCl8j1sKKzcEAGhCC3cr6UcMeta || {},
    component: () => import("/tmp/build_847345ee/pages/backstage/auth/register.vue")
  },
  {
    name: "backstage-invite-code",
    path: "/backstage/invite/:code()",
    meta: _91code_93Hw3vx0wQAG9Zkxq3Ja5O_C2MYs7P5D7zdK8__ML9uwcMeta || {},
    component: () => import("/tmp/build_847345ee/pages/backstage/invite/[code].vue")
  },
  {
    name: "app-integrations-discord",
    path: "/app/integrations/discord",
    meta: discord2Hjkrd2sjGpJEifu_45tDtH2ZD_45JXfuU3_45y9wNfQsnEBQMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/integrations/discord.vue")
  },
  {
    name: "backstage-dashboard",
    path: "/backstage/dashboard",
    meta: { ...(indexyv0bikET0j2CB_mDpnqLksLBsfyIUhrWuEBfKf7gtqIMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/index.vue")
  },
  {
    name: "main-questions-frequentes",
    path: "/main/questions-frequentes",
    meta: questions_45frequentes2wlAme0fByQxTn3YAbLPo6QL_453J9S6r9ziQ4AKvol9AMeta || {},
    component: () => import("/tmp/build_847345ee/pages/main/questions-frequentes.vue")
  },
  {
    name: "app-integrations-discord-auth",
    path: "/app/integrations/discord-auth",
    meta: discord_45auth4z8d0e__45I1C4YS2FIxCgd8324bZkrxsAPNNYBA0FOywMeta || {},
    component: () => import("/tmp/build_847345ee/pages/app/integrations/discord-auth.vue")
  },
  {
    name: "backstage-dashboard-subscribe",
    path: "/backstage/dashboard/subscribe",
    meta: { ...(subscriberpEDUNUPVYmEqB5Ep9ReYQBh43TMilnXMjCakaRhNnUMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/subscribe.vue")
  },
  {
    name: "backstage-dashboard-events",
    path: "/backstage/dashboard/events",
    meta: { ...(indexs0qLxuRgu7_k8_2VLy6drTIb724OhezxErtozlcVatUMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/events/index.vue")
  },
  {
    name: "backstage-dashboard-places",
    path: "/backstage/dashboard/places",
    meta: { ...(index8nOcIazOrF6vDgg3jvoPOOmnz5yGrH4jdfhfKpjSqJsMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/places/index.vue")
  },
  {
    name: _91slug_93Z2WSEC9oq5hwjkt3UoQArTfbbwzbTkNZgfynLJ2gy_wMeta?.name,
    path: "/backstage/dashboard/events/:slug()",
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/events/[slug].vue"),
    children: [
  {
    name: edit9d3vqlQA8kpD2zOOSo1fOtZ_0ir5Mx5xwIXw0twV4twMeta?.name,
    path: "edit",
    meta: { ...(edit9d3vqlQA8kpD2zOOSo1fOtZ_0ir5Mx5xwIXw0twV4twMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/edit.vue"),
    children: [
  {
    name: "backstage-dashboard-events-slug-edit",
    path: "",
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/edit/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-details",
    path: "details",
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/edit/details.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-advanced",
    path: "advanced",
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/edit/advanced.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-attendees",
    path: "attendees",
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/edit/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-slug",
    path: "",
    meta: { ...(indexFDz_45Pq6mzIJ_45vr5Pt9nZj0dorlHc_vJ9wEjRsXUMRvIMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-attendees",
    path: "attendees",
    meta: { ...(attendeesnVVI1Mt0hH_d_CV3EYaqs2z_453BriqgbtfcWRsKJioPkMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/events/[slug]/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-create",
    path: "/backstage/dashboard/events/create",
    meta: { ...(create4d73hejedQkaHecom5p53BOEzmPyjdO8puRuJk8ikMEMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/events/create.vue")
  },
  {
    name: "backstage-dashboard-settings",
    path: "/backstage/dashboard/settings",
    meta: { ...(index_453kRYBO__Pw2utcio_45eLlUnwRYuBoEwtqnpnPRyyIvwMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/settings/index.vue")
  },
  {
    name: "backstage-dashboard-organization",
    path: "/backstage/dashboard/organization",
    meta: { ...(indexczv_CQgOe9I_LpQbhWN7pkISCMwsWgbEKDt_JQuti1wMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_847345ee/pages/backstage/dashboard/organization/index.vue")
  },
  {
    name: component_45stub32_45B619_45qLik9Dit1RzctRZFqRO7e8r9OPlwhREQD2EMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub32_45B619_45qLik9Dit1RzctRZFqRO7e8r9OPlwhREQD2E
  }
]